export const USER_LOGIN_REQUEST = 'login/request'
export const USER_LOGIN_SUCCESS = 'login/success'
export const USER_LOGIN_ERROR = 'login/error'
export const USER_SIGNOUT = 'login/signout'